import classNames from 'classnames';
import { FC, MouseEventHandler } from 'react';

import styles from './FilterChip.styles.m.css';

interface IFilterChipProps {
  value: string;
  title: string;
  className?: string;
  isDisabled?: boolean;
  onClick(value: string): void;
  active?: boolean;
}

export const FilterChip: FC<IFilterChipProps> = (props) => {
  const { value, title, className, isDisabled, active, onClick } = props;
  const containerClassName = classNames(styles.container, className, {
    [styles.disabled]: isDisabled,
    [styles.active]: active,
  });

  const handleClick: MouseEventHandler = () => {
    onClick(value);
  };

  return (
    <div
      tabIndex={0}
      role="button"
      onClick={handleClick}
      className={containerClassName}
    >
      <div className={styles.content}>{title}</div>
    </div>
  );
};
